<script setup>
defineProps({
  width: {
    type: Number,
    default: 16,
  },
  height: {
    type: Number,
    default: 16,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1324_129118)">
      <path
        d="M20.7 1H3.3C2.05 1 1 2.05 1 3.3V15.75C1 17 2.05 18.05 3.3 18.05H5.9V23L11.2 18.05H20.7C21.95 18.05 23 17 23 15.75V3.3C23 2.05 21.95 1 20.7 1Z"
        fill="#8C8C8C"
      />
      <path
        d="M5.9 23.75C5.8 23.75 5.7 23.75 5.6 23.7C5.35 23.6 5.15 23.3 5.15 23V18.8H3.3C1.6 18.8 0.25 17.45 0.25 15.75V3.3C0.25 1.6 1.6 0.25 3.3 0.25H20.7C22.4 0.25 23.75 1.6 23.75 3.3V15.75C23.75 17.45 22.4 18.8 20.7 18.8H11.5L6.4 23.55C6.3 23.7 6.1 23.75 5.9 23.75ZM3.3 1.75C2.45 1.75 1.75 2.45 1.75 3.3V15.75C1.75 16.6 2.45 17.3 3.3 17.3H5.9C6.3 17.3 6.65 17.65 6.65 18.05V21.3L10.7 17.5C10.85 17.35 11 17.3 11.2 17.3H20.7C21.55 17.3 22.25 16.6 22.25 15.75V3.3C22.25 2.45 21.55 1.75 20.7 1.75H3.3Z"
        fill="#8C8C8C"
      />
      <path
        d="M4.40005 11.05C4.75005 11.25 5.30005 11.4 5.85005 11.4C6.45005 11.4 6.75005 11.15 6.75005 10.8C6.75005 10.45 6.50005 10.25 5.80005 10C4.85005 9.65 4.20005 9.15 4.20005 8.3C4.20005 7.3 5.00005 6.55 6.35005 6.55C7.00005 6.55 7.50005 6.7 7.80005 6.85L7.50005 7.9C7.25005 7.8 6.85005 7.65 6.30005 7.65C5.75005 7.65 5.45005 7.9 5.45005 8.2C5.45005 8.55 5.75005 8.75 6.50005 9C7.50005 9.35 8.00005 9.9 8.00005 10.7C8.00005 11.65 7.25005 12.5 5.70005 12.5C5.05005 12.5 4.40005 12.35 4.05005 12.15L4.40005 11.05Z"
        fill="white"
      />
      <path
        d="M13.8 10.2C13.75 9.5 13.75 8.7 13.75 7.85H13.7C13.5 8.6 13.3 9.4 13.05 10.05L12.35 12.3H11.35L10.75 10.1C10.55 9.45 10.35 8.6 10.25 7.85C10.2 8.6 10.2 9.5 10.15 10.25L10 12.4H8.80005L9.15005 6.65H10.9L11.45 8.55C11.65 9.2 11.8 9.95 11.95 10.6H12C12.15 9.95 12.35 9.2 12.55 8.55L13.15 6.65H14.85L15.15 12.4H13.9L13.8 10.2Z"
        fill="white"
      />
      <path
        d="M16.2001 11.05C16.5501 11.25 17.1001 11.4 17.6501 11.4C18.2501 11.4 18.5501 11.15 18.5501 10.8C18.5501 10.45 18.3001 10.25 17.6001 10C16.6501 9.65 16.0001 9.15 16.0001 8.3C16.0001 7.3 16.8001 6.55 18.1501 6.55C18.8001 6.55 19.2501 6.7 19.6001 6.85L19.3001 7.9C19.0501 7.8 18.6501 7.65 18.1001 7.65C17.5501 7.65 17.2501 7.9 17.2501 8.2C17.2501 8.55 17.5501 8.75 18.3001 9C19.3001 9.35 19.8001 9.9 19.8001 10.7C19.8001 11.65 19.0501 12.5 17.5001 12.5C16.8501 12.5 16.2001 12.35 15.8501 12.15L16.2001 11.05Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1324_129118">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
